import { Box, Button, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NavigationButton from "../../components/button/NavigationButton";
import { MdCheck, MdClose } from "react-icons/md";
import { Notification } from "../../db_access/notification";
import { getOrgTokens } from "../../theme/style/organizationPalette";

const MessageNotification = ({ notification, navigation, onActionComplete }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const tok = getOrgTokens(isDark);
  const navigate = useNavigate();

  const handleDecline = (e) => {
    e.stopPropagation();
    Notification.read([notification.id]).then(() => {
      if (onActionComplete) onActionComplete();
    });
  };

  const isRead = notification.is_read;

  return (
    <Box sx={{ 
        display: "flex", 
        alignItems: "center", 
        width: '100%',
        minHeight: '48px', // High density
        bgcolor: isRead ? 'transparent' : alpha(tok.bg.tabActive, 0.05),
        borderLeft: isRead ? '4px solid transparent' : `4px solid ${tok.bg.tabActive}`,
        transition: 'all 0.2s ease',
        px: 2,
        py: 1.5,
        position: 'relative'
    }}>
      {/* 1. Message Area */}
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        <Typography sx={{ 
            textAlign: "left", 
            fontFamily: tok.font.family, 
            fontWeight: 500,
            color: isRead ? tok.text.secondary : tok.text.primary,
            fontSize: '14px',
            lineHeight: 1.4
        }}>
          {notification.message}
        </Typography>
      </Box>

      {/* 2. Actions & Timestamp Area */}
      <Box sx={{ display: "flex", gap: 3, alignItems: "center", ml: 2 }}>
        {/* Support Request Specific Buttons */}
        {notification.type === "support_request" && !isRead && (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              size="small"
              variant="contained"
              onClick={(e) => {
                e.stopPropagation();
                if (onActionComplete) onActionComplete(notification.id);
              }}
              sx={{
                bgcolor: tok.bg.tabActive,
                '&:hover': { bgcolor: alpha(tok.bg.tabActive, 0.9) },
                textTransform: 'none',
                fontWeight: 700,
                borderRadius: '6px',
                px: 2,
                height: '28px',
                fontSize: '12px'
              }}
            >
              {t("Approve")}
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={handleDecline}
              sx={{
                color: theme.palette.error.main,
                borderColor: theme.palette.error.main,
                textTransform: 'none',
                fontWeight: 700,
                borderRadius: '6px',
                px: 2,
                height: '28px',
                fontSize: '12px'
              }}
            >
              {t("Decline")}
            </Button>
          </Box>
        )}

        {/* Fixed Timestamp Area */}
        <Typography sx={{ 
            fontFamily: tok.font.family, 
            fontWeight: 400, 
            fontSize: "12px", 
            color: tok.text.muted,
            minWidth: '130px',
            textAlign: 'right'
        }}>
          {notification.timestamp?.split(" GMT")[0]}
        </Typography>
      </Box>
    </Box>
  );
};

export default MessageNotification;
